import React from "react";
import { Tree } from "../../../lib/useTrees";
import { ComponentProps } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { TreeStamp } from "../../elements/TreeStamp/TreeStamp";
import * as styles from "./FeaturedTrees.module.css";

interface Props extends ComponentProps {
  subhead?: string;
  trees: Tree[];
}

export const FeaturedTrees: React.FC<Props> = ({
  subhead,
  trees,
  ...props
}) => {
  const containerClasses = [styles.treesContainer];
  trees.length === 2 && containerClasses.push(styles.twoColumns);

  return (
    <SectionWrapper {...props}>
      <section className={styles.featuredtrees}>
        {subhead && (
          <div className={styles.subhead}>
            <h2>{subhead}</h2>
          </div>
        )}
        <div className={containerClasses.join(" ")}>
          {trees.map((tree, idx) => {
            if (!tree.commonName) return null;

            return (
              <TreeStamp
                name={tree.commonName}
                image={tree.image}
                species={tree.scientificName}
                treeId={tree.treeId}
                cta={
                  tree?.page?.url
                    ? {
                        label: "View Details",
                        href: tree.page.url,
                        target: "_self",
                      }
                    : undefined
                }
                clickable={true}
                style="listing"
                key={`treeStamp-${idx}`}
              />
            );
          })}
        </div>
      </section>
    </SectionWrapper>
  );
};
